"use strict";

exports.__esModule = true;
exports["default"] = getDataFromTextComponent;
/* eslint-disable no-nested-ternary */

function getDataFromTextComponent(TextComponent) {
  var isRichText = false;
  var textProp = 'children';
  var textRaw = '';
  var textComponentIsString = typeof TextComponent === 'string';
  if (textComponentIsString) {
    return {
      isRichText: isRichText,
      textProp: textProp,
      textRaw: TextComponent,
      textComponentIsString: textComponentIsString
    };
  }
  isRichText = Boolean(TextComponent.props.html);
  textProp = isRichText ? 'html' : 'children';
  textRaw = isRichText ? TextComponent.props.html : TextComponent.props.children;
  textRaw = Array.isArray(textRaw) ? textRaw.join(' ') : textRaw;
  return {
    isRichText: isRichText,
    textProp: textProp,
    textRaw: textRaw,
    textComponentIsString: textComponentIsString
  };
}